import type { SubscriptionType } from '../types';

// Business-plan seat math, mirroring the server's LIMIT constants: the base
// plan includes a fixed number of seats and expands only in seat packs.
export const BUSINESS_INCLUDED_SEATS = 5;
export const BUSINESS_SEAT_PACK_SIZE = 5;
export const MAX_SEAT_PACKS = 50;

export const businessSeatLimit = (packs: number): number =>
  BUSINESS_INCLUDED_SEATS + BUSINESS_SEAT_PACK_SIZE * packs;

// Display-only price math; the amounts billed are the Stripe prices
// configured on the server.
export const BUSINESS_PRICES: Record<
  SubscriptionType,
  { base: number; pack: number }
> = {
  yearly: { base: 200, pack: 100 },
  monthly: { base: 20, pack: 10 },
};
